export const SET_AUTHENTICATION = "SET_AUTHENTICATION";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const GOOGLE_CLIENT_ID = "GOOGLE_CLIENT_ID";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";
export const SET_VIDEOS_LISTING_LOADING = "SET_VIDEOS_LISTING_LOADING";
export const SET_ANNOTATIONS_LISTING_LOADING =
  "SET_ANNOTATIONS_LISTING_LOADING";
export const CRED_LOGIN_ACTION = "CRED_LOGIN_ACTION";
